import axios from 'axios'
// import store from '../store/index'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.Img_API,
  // timeout: 15000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  // headers: { 'Content-Type': 'multipart/form-data' },
  withCredentials: false // 允许携带cookie
})

service.interceptors.request.use(config => {
  return config
}, error => {
//   console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(response => {
  // console.log(response)
  if (response.data.code === '200') {
    return response.data.data
  } else {
    Message({
      message: response.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return null
  }
}, error => {
  Message({
    message: error.msg,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/sealFilter/ImgAuthority.js